<div *ngIf="initialized" class="card">
  <!-- Header -->
  <header class="card-header bg-light py-3 px-5">
    <div class="d-flex justify-content-between align-items-center">
      <h3 class="h6 mb-0">Visitor Log</h3>

      <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </header>
  <!-- End Header -->

  <!-- Body -->
  <div #peopleContainer class="card-body" style="">
    <span class="ml-3 mr-2 mb-2"><a role="button" class="text-primary cursor-pointer" [ngClass]="{ selected: active }" (click)="active = true">Active</a></span>
    <span class="mr-2 mb-2"><a role="button" class="text-primary cursor-pointer" [ngClass]="{ selected: !active }" (click)="active = false">In-Active</a></span>
    <div class="participant-list" style="">
      <div>
        <ul>
          <ng-container *ngFor="let activeUser of activeUsers">
            <li *ngIf="activeUser.connected && active">
              <div class="d-flex align-items-center pb-3">
                <div class="mr-auto">
                  <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + activeUser.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ activeUser.id }}-avatar.png" />
                  <span class="participant-name ml-2">{{ activeUser.firstName }} {{ activeUser.lastName }} </span>
                  <span class="visitor-email"
                    ><a href="mailto:{{ activeUser.email }}">{{ activeUser.email }} </a></span
                  >
                </div>

                <span class="participant-menu">
                  <span *ngIf="activeUser.engagementIndex >= 0 && activeUser.engagementIndex <= 33" class="btn btn-icon btn-soft-danger rounded-circle mb-3">
                    <span class="btn-icon__inner">{{ activeUser.engagementIndex }}%</span>
                  </span>
                  <span *ngIf="activeUser.engagementIndex > 33 && activeUser.engagementIndex <= 70" class="btn btn-icon btn-soft-warning rounded-circle mb-3">
                    <span class="btn-icon__inner">{{ activeUser.engagementIndex }}%</span>
                  </span>
                  <span *ngIf="activeUser.engagementIndex > 70 && activeUser.engagementIndex <= 100" class="btn btn-icon btn-soft-success rounded-circle mb-3">
                    <span class="btn-icon__inner">{{ activeUser.engagementIndex }}%</span>
                  </span>
                </span>

                <!-- <span *ngIf="user.id == activeUser.id" class="participant-menu">
                  <strong>This is you</strong>
                </span> -->
              </div>
            </li>
            <li *ngIf="!activeUser.connected && !active">
              <div class="d-flex align-items-center pb-3">
                <div class="mr-auto">
                  <img class="avatar u-sm-avatar rounded-circle" [fallback]="'fetch-avatar?userId=' + activeUser.id" src="https://bxlimages.blob.core.windows.net/avatar-cache/{{ activeUser.id }}-avatar.png"  />
                  <span class="participant-name ml-2">{{ activeUser.firstName }} {{ activeUser.lastName }} </span>
                  <span class="visitor-email"
                    ><a href="mailto:{{ activeUser.email }}">{{ activeUser.email }} </a></span
                  >
                </div>

                <span class="participant-menu">
                  <span *ngIf="activeUser.engagementIndex >= 0 && activeUser.engagementIndex <= 33" class="btn btn-icon btn-soft-danger rounded-circle mb-3">
                    <span class="btn-icon__inner">{{ activeUser.engagementIndex }}%</span>
                  </span>
                  <span *ngIf="activeUser.engagementIndex > 33 && activeUser.engagementIndex <= 70" class="btn btn-icon btn-soft-warning rounded-circle mb-3">
                    <span class="btn-icon__inner">{{ activeUser.engagementIndex }}%</span>
                  </span>
                  <span *ngIf="activeUser.engagementIndex > 70 && activeUser.engagementIndex <= 100" class="btn btn-icon btn-soft-success rounded-circle mb-3">
                    <span class="btn-icon__inner">{{ activeUser.engagementIndex }}%</span>
                  </span>
                </span>

                <!-- <span *ngIf="user.id == activeUser.id" class="participant-menu">
                  <strong>This is you</strong>
                </span> -->
              </div>
            </li>
          </ng-container>
        </ul>
      </div>
    </div>
    <a class="ml-3 mt-2" target="_blank" href="api/exhibits/{{ exhibit.id }}/export?access_token={{ auth.getToken() }}">Download user data</a>
  </div>
  <!-- End Body -->

  <!-- End Footer -->
</div>
